import HTTP from "../plugins/backendAPI";
import { DEFAULT_PASSWORD_POLICY } from "./constants";

export class PasswordPolicyHelper {
  constructor(passwordPolicy = null) {
    this.passwordPolicy = passwordPolicy || {
      minLength: 0,
      specialChars: 0,
      numbers: 0,
    };
  }

  async fetchPasswordPolicy(identifier) {
    let url = identifier.organizationId
      ? `/organization/${identifier.organizationId}/get/password-policy`
      : `/organization/get/password-policy?guid=${identifier.guid}`;

    try {
      const response = await HTTP.get(url);
      if (!response || !response.data || !response.data.passwordRequirementRegex) {
        this.passwordPolicy = {
          ...DEFAULT_PASSWORD_POLICY,
          regex: DEFAULT_PASSWORD_POLICY.regex.source,
        };
      } else {
        this.passwordPolicy = this.parsePasswordPolicyFromRegex(response.data.passwordRequirementRegex);
      }

      this.updatePasswordHint();
      this.updatePasswordRules();
    } catch (error) {
      console.error("Error when fetchin passwordpolicy:", error);

      this.passwordPolicy = {
      ...DEFAULT_PASSWORD_POLICY,
      regex: DEFAULT_PASSWORD_POLICY.regex.source,
    };
    }
  }

  parsePasswordPolicyFromRegex(passwordRequirementRegex) {
    const minLengthMatch = passwordRequirementRegex.match(/(?=.\{(\d+),})/);
    const specialCharsCountMatch = passwordRequirementRegex.match(/\(\?=(?:.*?[!@#$%^&*()\-_=+{};:,<.>]+){(\d+)}\)/);
    const numbersMatch = passwordRequirementRegex.match(/\(\?=(?:.*?\d+){(\d+)}\)/);

    return {
      minLength: minLengthMatch ? parseInt(minLengthMatch[1]) : DEFAULT_PASSWORD_POLICY.minLength,
      specialChars: specialCharsCountMatch ? parseInt(specialCharsCountMatch[1]) : DEFAULT_PASSWORD_POLICY.specialChars,
      numbers: numbersMatch ? parseInt(numbersMatch[1]) : DEFAULT_PASSWORD_POLICY.numbers,
      regex: passwordRequirementRegex,
    };
  }

  updatePasswordHint() {
    return `Min length: ${this.passwordPolicy.minLength}, Specialcharacter${
      this.passwordPolicy.specialChars === 1 ? "" : "s"
    }: ${this.passwordPolicy.specialChars}, Number${this.passwordPolicy.numbers === 1 ? "" : "s"}: ${
      this.passwordPolicy.numbers
    }`;
  }

  updatePasswordRules() {
    return [
      (v) => !!v || this.updatePasswordHint(),
      (v) => (v && v.length >= this.passwordPolicy.minLength) || `Min length ${this.passwordPolicy.minLength}`,
      (v) =>
        ((v && v.match(/[^A-Za-z0-9\s]/g)) || []).length >= this.passwordPolicy.specialChars ||
        `Min ${this.passwordPolicy.specialChars} Specialcharacter${this.passwordPolicy.specialChars === 1 ? "" : "s"}`,
      (v) =>
        ((v && v.match(/[0-9]/g)) || []).length >= this.passwordPolicy.numbers ||
        `Min ${this.passwordPolicy.numbers} Number${this.passwordPolicy.numbers === 1 ? "" : "s"}`,
    ];
  }

  validatePassword(password) {
    if (!this.passwordPolicy?.regex) {
      console.error("No regex found for validation.");
      return false;
    }
    
    try {
      const regex = new RegExp(this.passwordPolicy.regex);
      return regex.test(password);
    } catch (e) {
      console.error("Invalid regex pattern:", e);
      return false;
    }
  }
}
